import type { Theme } from './ThemeContext';

/**
 * Theme configuration
 * Change the value below to switch themes: 'dark' | 'light'
 */
export const theme: Theme = 'light';
